import { UserWithCompany } from "frontend/utils/types";
import { getDisplayEmail } from "services/user";

export function identifyHeapUser(user: UserWithCompany) {
  if (!window.heap) return;
  // @ts-expect-error TS2345
  window.heap.identify(getDisplayEmail(user) ?? "");
}
